import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

// Async thunk for fetching mentorship offerings
export const fetchMentorshipOffered = createAsyncThunk(
  'mentorship/fetchMentorshipOffered',
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient({
        url: API_ENDPOINTS.GET_MENTORSHIP_OFFERED,
        method: 'get',
        withAuth: true,
      });
      
      return res?.data?.data || [];
    } catch (error) {
      console.error('Mentorship fetch error:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch mentorship offerings');
    }
  }
);

const mentorshipSlice = createSlice({
  name: 'mentorship',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMentorshipOffered.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMentorshipOffered.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetched = Date.now();
        state.error = null;
      })
      .addCase(fetchMentorshipOffered.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = mentorshipSlice.actions;
export default mentorshipSlice.reducer;
